import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import FormsModal from "../../components/userForms/FormsModal";
import "../../pages/Landing/Landing.css";
import sky from "./sky.png";
import "./responsive.css";

export default function HomeHeader({ tab, showPaymentPopup }) {
  const [accountType, setAccountType] = useState("/");
  let token = localStorage?.getItem("skiUserToken");
  useEffect(() => {
    if (token) {
      const decodedToken = jwt_decode(token);
      const { AccountType } = decodedToken;
      setAccountType(AccountType);
    }
  }, [token]);
  return (
    <>
      <div className="Header HomeHeader">
        <div className="header-ski-logo">
          <a href="https://skyestudio.netlify.app" target="_blank">
            <img src={sky} alt="Skisign" className="image" />
          </a>
        </div>
        <div className="home-header-nav">
          <Link
            to={"/" + accountType + "-home"}
            className={tab === "home" ? "active" : ""}
          >
            Home
          </Link>
          {accountType === "client" && (
            <Link
              to="/ski-contents"
              className={tab === "contents" ? "active" : ""}
            >
              Contents
            </Link>
          )}
          <Link
            to="/"
            onClick={() => {
              localStorage.removeItem("skiUserToken");
              window.location = "/";
            }}
          >
            Logout
          </Link>
          {accountType !== "client" && (
            <Link to="/account" className={tab === "account" ? "active" : ""}>
              Account
            </Link>
          )}
        </div>
        {accountType === "client" ? (
          <div>
            <button className="btn" onClick={() => showPaymentPopup("flex")}>
              <img src="/SVG/Star.svg" alt="Star Icon" />
              &nbsp;&nbsp; Upgrade to Skye Pro
            </button>
            <p>
              Get More Design monthly for <span>$29.99/month</span>
            </p>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <FormsModal />
    </>
  );
}
